/* GASSISA
 * Helper compartido PrinterTools: validación de estado de impresoras.
 * Usa los microservicios del agente local:
 *   POST http://localhost:4000/api/impresoras/validar  { printerName }
 * Respuesta: { exists, available, canPrint, statusCode, message, ... }
 * Solo errores duros bloquean (canPrint=false); warnings permiten imprimir.
 */

export const PRINTERTOOLS_BASE_URL = "http://localhost:4000";

export const resolverNombreImpresoraEtiqueta = (parametrosCajaForm) => {
  try {
    const deStorage = (localStorage.getItem("nombreimpresoraetiqueta") || "").trim();
    if (deStorage) return deStorage;
  } catch { /* localStorage no disponible */ }
  return (parametrosCajaForm?.nombreimpresoraetiqueta || "").trim();
};

export const guardarNombreImpresoraEtiqueta = (printerName) => {
  try {
    const nombre = String(printerName || "").trim();
    if (nombre) localStorage.setItem("nombreimpresoraetiqueta", nombre);
  } catch { /* localStorage no disponible */ }
};

export const validarEstadoImpresoraPrinterTools = async (printerName) => {  const nombre = String(printerName || "").trim();
  if (!nombre) {
    return {
      canPrint: false,
      exists: false,
      statusCode: "NOT_FOUND",
      message: "No se encontró la impresora de etiquetas configurada. Configure la impresora en Parámetros de Caja.",
      printerName: "",
    };
  }
  try {
    const response = await fetch(`${PRINTERTOOLS_BASE_URL}/api/impresoras/validar`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ printerName: nombre }),
    });
    const data = await response.json().catch(() => ({}));
    // Sin forma nueva (canPrint/statusCode) = agente viejito sin /validar.
    if (data?.canPrint === undefined || data?.statusCode === undefined) {
      return {
        canPrint: false,
        exists: false,
        statusCode: "AGENTE_DESACTUALIZADO",
        message: "PrinterTools desactualizado: instala la versión nueva desde Seguridad > downloads y reintenta.",
        printerName: nombre,
      };
    }
    const canPrint = response.ok && data?.canPrint === true;
    return {
      canPrint,
      exists: data?.exists === true,
      statusCode: data?.statusCode || (response.ok ? "OK" : "NOT_AVAILABLE"),
      message: data?.message || "Estado de impresora no disponible",
      printerName: data?.printerName || nombre,
      warnings: Array.isArray(data?.warnings) ? data.warnings : [],
    };
  } catch (error) {
    return {
      canPrint: false,
      exists: false,
      statusCode: "NOT_AVAILABLE",
      message: `PrinterTools no responde: ${error?.message || error}`,
      printerName: nombre,
    };
  }
};

/* Lista de impresoras con estado (para Autocomplete).
 * Intenta GET /api/impresoras/detalle (con canPrint/statusCode);
 * si el agente es viejito, cae a GET /api/impresoras (solo nombres).
 */
export const listarImpresorasConEstado = async () => {
  try {
    const response = await fetch(`${PRINTERTOOLS_BASE_URL}/api/impresoras/detalle`);
    if (response.ok) {
      const data = await response.json().catch(() => []);
      if (Array.isArray(data)) {
        return data
          .map((p) => ({
            name: String(p?.name || p?.printerName || "").trim(),
            canPrint: p?.canPrint === true,
            statusCode: p?.statusCode || "UNKNOWN",
            message: p?.message || "",
          }))
          .filter((p) => p.name);
      }
    }
  } catch { /* fallback abajo */ }
  try {
    const response = await fetch(`${PRINTERTOOLS_BASE_URL}/api/impresoras`);
    if (!response.ok) return [];
    const data = await response.json().catch(() => []);
    const lista = Array.isArray(data) ? data : [];
    return [...new Set(
      lista.map((p) => String(p?.name || "").trim()).filter(Boolean)
    )].map((name) => ({ name, canPrint: true, statusCode: "UNKNOWN", message: "" }));
  } catch {
    return [];
  }
};

/* Lee el cuerpo de error de PrinterTools (JSON {error|message} o texto).
 * Los endpoints responden 400/500 con el motivo real ("La impresora 'X' no
 * está disponible"); sin esto solo se ve el statusText genérico ("Bad Request").
 */
export const leerMensajeErrorPrinterTools = async (response, respaldo = "") => {
  const base = respaldo || `PrinterTools respondió ${response?.status || "error"}`;
  try {
    const texto = await response.text();
    if (!texto) return base;
    try {
      const data = JSON.parse(texto);
      return data?.error || data?.message || texto;
    } catch {
      return texto;
    }
  } catch {
    return base;
  }
};
